// A route that fails to load or render shows an in-app error with a way back, never react-router's bare crash
// screen. A failed page-code load is retried by reloading the page (see moduleLoadError.ts).
import { Link, isRouteErrorResponse, useRouteError } from "react-router";
import { btn } from "@/components/actions";
import { Callout } from "@/components/kit";
import { isModuleLoadError } from "./moduleLoadError";

function describe(error: unknown): { title: string; detail: string; missing: boolean } {
  if (isRouteErrorResponse(error)) {
    const missing = error.status === 404;
    return {
      title: missing ? "This page does not exist" : `The page answered ${error.status}`,
      detail: missing ? "No page answers this address. Check the link, or go back to a project." : error.statusText || "The request for this page failed.",
      missing,
    };
  }
  if (isModuleLoadError(error)) {
    return {
      title: "This page could not be loaded",
      detail: "Its code did not load, usually because the application was updated while this tab was open. Reload to fetch the current version; nothing was changed.",
      missing: false,
    };
  }
  return {
    title: "This page stopped with an error",
    detail: error instanceof Error ? error.message : String(error),
    missing: false,
  };
}

/** Rendered by a route's error boundary: inside the shell for page errors, full page when the shell itself fails. */
export function RouteError() {
  const error = useRouteError();
  const { title, detail, missing } = describe(error);
  return (
    <div className="mx-auto max-w-2xl p-6" data-testid="route-error">
      <Callout tone="bad" title={title} actions={<>
        {!missing && <button type="button" className={btn()} onClick={() => window.location.reload()} data-testid="route-error-reload">Reload page</button>}
        <Link to="/" className={btn("plain")}>All projects</Link>
      </>}>
        <span className="text-danger">{detail}</span>
      </Callout>
    </div>
  );
}
